import { post } from "../../api";

const getNoResults = body => post("noResults", {}, body, null);
const brandNewArrivals = body => post("brandNewArrivals", {}, body, null);
const brandOnSale = body => post("brandOnSale", {}, body, null);
export { getNoResults, brandNewArrivals, brandOnSale };
